import { Theme } from "@mui/material"

export default (theme: Theme) => ({
  fontFamily: 'AlphaHeadlinePro-Bold, sans-serif',
  fontSize: '12px',
  color: theme.palette.secondary.main
} as const);